module.exports = __webpack_public_path__ + "static/img/D1.a990325.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/D1.png
// module id = Q23C
// module chunks = 0